import React, { FC } from "react";
import { MessageProps } from "../../../typings/messages";
import Day from "./Day";
import Ticks from "./Ticks";
import { isSameDay, isSameUser } from "./utils";
import MessageText from './MessageText'
import MessageLocation from './MessageLocation';
import MessageImage from './MessageImage';
import MessageProfileImages from './MessageProfileImages';
import MessageBreakTheIce from './MessageBreakTheIce';


export type MessageChatProps = {
    key: number;
    currentMessage: MessageProps;
    previousMessage: MessageProps;
    nextMessage: MessageProps;
    chatMemberImage: string | null;
    answerBreakTheIce: (data: any) => void;
    sendBreakTheIce: (data: any) => void;
    position: string;
    imageMessages: (string | null)[];
    memberCode: number;
    chatRecipientNickName: string;
}


const Message: FC<MessageChatProps> = (props) => {
    const sameUser = isSameUser(props.currentMessage, props.nextMessage);
    const isMyMessage = props.memberCode === props.currentMessage.chatMemberCode;
    const renderTicks = () => {
        const { currentMessage, memberCode } = props;
        if (currentMessage.sent || currentMessage.pending) {
            return <Ticks currentMessage={currentMessage} isMe={isMyMessage} chatRecipientNickName={props.chatRecipientNickName} />
        }
        return null;
    }


    const renderDay = () => {
        if (props.currentMessage.createdAt) {
            if (isSameDay(props.currentMessage, props.nextMessage)) {
                return null;
            }
            else return <Day currentMessage={props.currentMessage} />
        }
    }

    const renderMessage = (message: MessageProps) => {
        if (props.currentMessage && props.currentMessage.text && props.currentMessage.text.length > 0) {
            const isImage = props.currentMessage.image != null && props.currentMessage.image.length > 0;
            const isVideo = props.currentMessage.video != null && props.currentMessage.video.length > 0;
            const isAudio = props.currentMessage.audio != null && props.currentMessage.audio.length > 0;
            const isBreakTheIce = props.currentMessage.breakTheIce != null;
            if (isImage === false && isVideo === false && isAudio === false && isBreakTheIce === false)
                return <MessageText message={message} position={props.position} renderTicks={renderTicks} />
        }
    }

    const renderLoactionMessage = (message: MessageProps) => {
        if (props.currentMessage.location)
            return <MessageLocation currentMessage={message} position={props.position} renderTicks={renderTicks} />
    }

    const renderMessageImage = (message: MessageProps) => {
        if (props.currentMessage.image)
            if (typeof props.currentMessage.image === "string")
                return <MessageImage imageMessages={props.imageMessages} message={message} position={props.position} renderTicks={renderTicks} />
            else
                return <MessageProfileImages message={message} position={props.position} renderTicks={renderTicks} />
    }

    const renderMessageBreakTheIce = (message: MessageProps) => {
        if (props.currentMessage.breakTheIce)
            return <MessageBreakTheIce sendBreakTheIce={props.sendBreakTheIce} answerBreakTheIce={props.answerBreakTheIce} chatMemberImage={props.chatMemberImage} message={message} position={props.position} renderTicks={renderTicks} />
    }


    return (
        <>

            {renderDay()}
            {renderMessage(props.currentMessage)}
            {renderLoactionMessage(props.currentMessage)}
            {renderMessageImage(props.currentMessage)}
            {renderMessageBreakTheIce(props.currentMessage)}
        </>
    )
}

export default Message;